import {
  SIMPLE_TEE_TIMES_ARRIVAL_DAY_OPTIONS,
  SIMPLE_TEE_TIMES_ARRIVAL_DEFAULT_VALUE,
  SIMPLE_TEE_TIMES_DEFAULT_VALUE,
  SIMPLE_TEE_TIMES_OPTIONS,
  SIMPLE_TEE_TIMES_WEEKEND_DEFAULT_VALUE,
  SIMPLE_TEE_TIMES_WEEKEND_OPTIONS,
} from "@booking/booking/store/simpleTeeTimes/constants";
import { SimpleTeeTimesOption } from "@booking/booking/store/simpleTeeTimes/types";
import { getHours, isSameDay, isWeekend } from "date-fns";

export const teeTimeDefaultValue = (arrival: Date, date: Date) => {
  if (isSameDay(arrival, date)) return SIMPLE_TEE_TIMES_ARRIVAL_DEFAULT_VALUE;

  if (isWeekend(date)) return SIMPLE_TEE_TIMES_WEEKEND_DEFAULT_VALUE;

  return SIMPLE_TEE_TIMES_DEFAULT_VALUE;
};

export const buildOptions = (
  teeTimesOptions: Record<string, string>,
): Array<SimpleTeeTimesOption> => {
  return Object.entries(teeTimesOptions).map(([value, label]) => ({
    value,
    label,
  }));
};

export const buildSimpleTeeTimesOptions = () => ({
  defaultOptions: buildOptions(SIMPLE_TEE_TIMES_OPTIONS),
  weekendOptions: buildOptions(SIMPLE_TEE_TIMES_WEEKEND_OPTIONS),
  arrivalOptions: buildOptions(SIMPLE_TEE_TIMES_ARRIVAL_DAY_OPTIONS),
});

export const getSimpleTeeTimeSlotOffset = (date: Date, defaultOffset = 2) => {
  return getHours(date) === SIMPLE_TEE_TIMES_ARRIVAL_DEFAULT_VALUE
    ? 3
    : defaultOffset;
};
